import { LocalStorageKeyEnum } from '../enums/local-storage.enum';

/**
 * @description Saves a value into localStorage. Right now this only saves strings or objects, anything else is completely ignored!
 */
export function updateLocalStorage<T>(key: LocalStorageKeyEnum | string, value: T): void {
  if (typeof value === 'string') localStorage.setItem(key, value);
  if (typeof value === 'object') localStorage.setItem(key, JSON.stringify(value));
}

/**
 * @description Gets a value out of localStorage if it exists, or returns `null` if not.
 * Any stored object are returned fully parsed.
 * If you provide a generic type it will be returned with that type as well
 */
export function checkLocalStorage<T>(key: LocalStorageKeyEnum | string): T | null {
  try {
    const stored = localStorage.getItem(key);
    if (typeof stored === 'undefined' || stored === null) {
      return null;
    } else if (typeof stored === 'string') {
      return JSON.parse(stored) as T;
    } else if (typeof stored === 'object') {
      return JSON.parse(stored) as T;
    }
    return null;
  } catch (ex: unknown) {
    console.error(`Error when attempting to parse data saved in localStorage for '${key}'`, ex);
    return null;
  }
}
